import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../../modules/infra/i18n';
import { serviceItemShape } from '../shapes';
import ServiceItem from '../containers/ServiceItem';
import CheckboxButton from '../../../../common/CheckboxButton';

const ServicesTable = ({ services, allSelected, setAllSelected }) => (
  <div className="c-wrapper">
    <div className="u-max-width-1000 u-margin-auto u-mv-">
      <div>
        <div className="c-table-card c-table-new u-table-layout-fixed c-no-hover c-even-odd">
          <div className="c-table-card__row c-table-card__row--transparent">
            <div className="c-table-card__cell u-2/10">
              <CheckboxButton
                onClick={() => setAllSelected(!allSelected)}
                label={t('common:table.select_all')}
                checkedLabel={t('common:table.deselect_all')}
                checked={allSelected}
                display-if={services.length > 1}
              />
            </div>
            <div className="c-table-card__cell u-4/10 c-table-header-grey">{t('common:table.name_header')}</div>
            <div className="c-table-card__cell u-4/10 c-table-header-grey">{t('common:table.categories_header')}</div>
          </div>
          {services.length > 0 && services.map(service => <ServiceItem service={service} key={service.id} />)}
        </div>
      </div>
    </div>

  </div>
);

ServicesTable.propTypes = {
  services: PropTypes.arrayOf(serviceItemShape).isRequired,
  allSelected: PropTypes.bool.isRequired,
  setAllSelected: PropTypes.func.isRequired,
};

export default ServicesTable;
